// Service Worker registration ve helper fonksiyonları

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('Service worker is ready (localhost)');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('✅ Service Worker registered:', registration);
      
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content is available; please refresh.');
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('Content is cached for offline use.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// IndexedDB helper fonksiyonları
const DB_NAME = 'ParkManagementDB';
const DB_VERSION = 1;
const LOCATION_STORE = 'offline-locations';

export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(LOCATION_STORE)) {
        const objectStore = db.createObjectStore(LOCATION_STORE, { 
          keyPath: 'id', 
          autoIncrement: true 
        });
        objectStore.createIndex('timestamp', 'timestamp', { unique: false });
        objectStore.createIndex('synced', 'synced', { unique: false });
      }
    };
  });
}

export async function saveOfflineLocation(locationData) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([LOCATION_STORE], 'readwrite');
      const objectStore = transaction.objectStore(LOCATION_STORE);
      
      const data = {
        ...locationData,
        synced: false,
        saved_at: new Date().toISOString()
      };
      
      const request = objectStore.add(data);
      request.onsuccess = () => {
        console.log('📦 Location saved offline:', data);
        resolve(request.result);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error('Failed to save offline location:', error);
    throw error;
  }
}

export async function getOfflineLocationCount() {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([LOCATION_STORE], 'readonly');
      const objectStore = transaction.objectStore(LOCATION_STORE);
      
      // Tüm kayıtları getir ve synced=false olanları filtrele
      const request = objectStore.getAll();
      
      request.onsuccess = () => {
        const allRecords = request.result || [];
        const unsyncedRecords = allRecords.filter(record => record.synced === false);
        resolve(unsyncedRecords.length);
      };
      request.onerror = () => {
        console.error('IndexDB getAll error:', request.error);
        resolve(0);
      };
    });
  } catch (error) {
    console.error('Failed to get offline location count:', error);
    return 0;
  }
}

export function requestSync() {
  if ('serviceWorker' in navigator && 'sync' in window.ServiceWorkerRegistration.prototype) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.sync.register('sync-locations')
        .then(() => {
          console.log('🔄 Background sync registered');
        })
        .catch((error) => {
          console.error('Background sync registration failed:', error);
        });
    });
  } else {
    // Background Sync desteklenmiyor, manuel sync yap
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'SYNC_NOW'
      });
    }
  }
}
